import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';

@Component({
  selector: 'ze-read-only-badge',
  templateUrl: './read-only-badge.component.html',
  styleUrls: ['./read-only-badge.component.scss']
})
export class ReadOnlyBadgeComponent implements OnInit, OnDestroy {
  isReadOnly = false;
  featureLabel = '';
  private routerSub: Subscription;
  private accessSub: Subscription;
  private currentFeatureCode: string | null = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private featureAccessService: FeatureAccessService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Re-evaluate whenever access map changes (e.g. after hard refresh load)
    this.accessSub = this.featureAccessService.accessMap.subscribe(() => {
      this.evaluate();
    });

    // Re-evaluate whenever the route changes
    this.routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.currentFeatureCode = this.getDeepestFeatureCode();
        this.evaluate();
      });

    // Evaluate on initial load
    this.currentFeatureCode = this.getDeepestFeatureCode();
    this.evaluate();
  }

  private getDeepestFeatureCode(): string | null {
    let route = this.activatedRoute.root;
    let featureCode: string | null = null;
    while (route) {
      if (route.snapshot.data && route.snapshot.data['feature']) {
        featureCode = route.snapshot.data['feature'];
      }
      route = route.firstChild;
    }
    return featureCode;
  }

  private evaluate() {
    if (!this.currentFeatureCode) {
      this.isReadOnly = false;
      this.cdr.markForCheck();
      return;
    }
    const access = this.featureAccessService.getAccess(this.currentFeatureCode);
    this.isReadOnly = access === 'READ_ONLY';
    this.cdr.markForCheck();
  }

  ngOnDestroy() {
    if (this.routerSub) this.routerSub.unsubscribe();
    if (this.accessSub) this.accessSub.unsubscribe();
  }
}
